// The site's web address, in one place. Everything that names the site reads
// it from here: search and share tags, the sitemap, email links, the /live
// share link, the presentation slides, Stripe's return pages, guest invites.
//
// gp85.com is the main address since Oct 29 2026 (bought Oct 27; the zone and
// the Worker's custom domains came first, SETUP.md §7). With SWITCHED_TO_GP85
// on, every gregpryor85.com page answers with a permanent redirect to the same
// page on gp85.com, and every link, email and tag names gp85.com. Off, it's
// the old site again on gregpryor85.com, with the show's pages under /gp85.
//
// What never moves (functions/_lib/main-address.js): the site's own requests
// (/api/*): Stripe's webhook and the one-click unsubscribe in emails already
// sent post to gregpryor85.com, and neither follows a redirect. Greg's console
// (/admin, /golive) moved with everything else on Oct 29 2026, Max's call: one
// address for all of it (a browser keeps the sign-in and the camera permission
// per address, so Greg signed in once more on gp85.com and allowed the camera
// again).

export const SWITCHED_TO_GP85 = true;

export const OLD_HOST = "gregpryor85.com";
export const NEW_HOST = "gp85.com";

// The address the site goes by: what people see, say and share.
export const MAIN_HOST = SWITCHED_TO_GP85 ? NEW_HOST : OLD_HOST;
export const SITE_URL = `https://${MAIN_HOST}`;

// Every production address the Worker answers on.
export const SITE_HOSTS = [OLD_HOST, `www.${OLD_HOST}`, NEW_HOST, `www.${NEW_HOST}`];

// Greg's console, on the main address like everything else.
export const CONSOLE_HOST = MAIN_HOST;
export const CONSOLE_URL = `https://${CONSOLE_HOST}/admin`;

// index.html, public/sitemap.xml and public/robots.txt are written with
// https://gregpryor85.com; the build (vite.config.js) passes them through this,
// so they name the main address. Until the switch it changes nothing.
export function toMainAddress(text, siteUrl = SITE_URL) {
  return text.replaceAll(`https://${OLD_HOST}`, siteUrl);
}
